import React from 'react';

import Label from './Label';
import { ErrorLabelProps } from './types';

const ErrorLabel = ({ id, text, className, icon, ...rest }: ErrorLabelProps): React.JSX.Element => {
    return <Label id={id} text={text} type="error" icon={icon} className={className} role="alert" {...rest} />;
};

export default ErrorLabel;
